module.exports = __webpack_public_path__ + "static/media/fan.3aadc09d.svg";